// src/helpers/tokenHelper.js

/**
 * Obtiene el token JWT del localStorage usando la misma lógica que apiHelper.js
 * @returns {string|null} El token JWT o null si no existe
 */
export const getAuthToken = () => {
    try {
        const storedData = localStorage.getItem('auth-storage-petitprime');
        if (storedData) {
            const parsedData = JSON.parse(storedData);
            return parsedData?.state?.token || null;
        }
    } catch (error) {
        console.error('Error parsing auth storage:', error);
    }
    return null;
};

/**
 * Verifica si el usuario está autenticado
 * @returns {boolean} true si hay un token válido, false en caso contrario
 */
export const isAuthenticated = () => {
    const token = getAuthToken();
    if (!token) return false;

    try {
        // Decodificar el token JWT para verificar si ha expirado
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const decodedToken = JSON.parse(jsonPayload);
        return decodedToken.exp > Date.now() / 1000;
    } catch (error) {
        console.error('Error decoding token:', error);
        return false;
    }
};

/**
 * Obtiene información del token decodificado
 * @returns {object|null} Información del token o null si no es válido
 */
export const getTokenInfo = () => {
    const token = getAuthToken();
    if (!token) return null;

    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
}; 
